var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-10",staticStyle:{"height":"100vh"}},[_vm._v("You are successfully login to GHM DataPortal.")])}
var staticRenderFns = []

export { render, staticRenderFns }